module.exports = __webpack_public_path__ + "img/la.9679002a.svg";